module.exports = __webpack_public_path__ + "blackhop.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackhop.png
// module id = 856
// module chunks = 0